export const PHONE = '+55 42 99116-8200';
export const EMAIL = 'atendimento@puchtaengenharia.com.br';
export const MESSAGE =
  'Olá! Tenho interesse em receber mais informações sobre os serviços e produtos da Puchta Engenharia!';
